export function NotFound(): JSX.Element {
    return (
        <div>
            <p>404 page</p>
        </div>
    )
}
